import { jsx } from "react/jsx-runtime";
import { SimonFields } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const BlockSimonFields = ({
  attrs,
  index,
  innerBlocks
}) => {
  const {
    buttonText,
    legalText = 'By submitting this form, you agree to receive email communication from Zillow. We respect your privacy. See our <a target="_blank" href="https://www.zillow.com/corp/Privacy.htm">privacy policy</a>.'
  } = attrs;
  return /* @__PURE__ */ jsx(SimonFields, { buttonText, legalText: makeContentInteractive(legalText), children: generateBlockList({
    blocks: innerBlocks
  }) }, index);
};
BlockSimonFields.propTypes = {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
};
export {
  BlockSimonFields as default
};
